import { login, getInfo } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { resetRouter } from '@/router'

const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',
    avatar: '',
    roles: []
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password }).then(response => {
        const { data } = response
        commit('SET_TOKEN', data.token)
        setToken(data.token)
        // 设置用户基本信息
        if (data.userInfo) {
          commit('SET_NAME', data.userInfo.name)
          commit('SET_AVATAR', data.userInfo.avatar)
          commit('SET_ROLES', data.userInfo.roles || ['admin'])
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      // 如果是管理员token，直接返回管理员信息
      if (state.name && state.roles.includes('admin')) {
        resolve({
          name: state.name,
          avatar: state.avatar,
          roles: state.roles
        })
        return
      }

      // 对于管理员登录，直接设置管理员信息
      if (state.token) {
        const name = '管理员'
        const avatar = ''
        const roles = ['admin']

        commit('SET_ROLES', roles)
        commit('SET_NAME', name)
        commit('SET_AVATAR', avatar)
        resolve({ name, avatar, roles })
        return
      }

      getInfo().then(response => {
        const { data } = response

        if (!data) {
          return reject('验证失败，请重新登录.')
        }

        // 对于普通用户，适配响应数据
        const name = data.nickname || data.name || '管理员'
        const avatar = data.avatar || ''
        const roles = ['admin'] // 管理后台只有管理员角色

        commit('SET_ROLES', roles)
        commit('SET_NAME', name)
        commit('SET_AVATAR', avatar)
        resolve({ name, avatar, roles })
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit }) {
    // 管理员 token 由 /admin/login 签发，不属于 /auth/logout 的普通用户会话。
    // 当前管理员会话没有服务端状态，退出时只需可靠清除本地凭据；不能因为
    // 请求普通用户退出接口被 403 或网络异常而让管理员留在已登录页面。
    removeToken()
    resetRouter()
    commit('RESET_STATE')
    return Promise.resolve()
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
